import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class FtcSourcingSummaryService {

  constructor(private http: HttpClient) {}

  saveDefaults(baseUrl: string, globalParams: any, filterParams: any, settings: any, details: any[]): Observable<any> {
    return this.postSave(baseUrl, 'w9eqdy', 'sourcing-grid-save', globalParams, filterParams, settings, details);
  }

  saveQarCustomTag(baseUrl: string, globalParams: any, filterParams: any, settings: any, details: any[]): Observable<any> {
    return this.postSave(baseUrl, 'u2qza7', 'qar-custom-tag-save', globalParams, filterParams, settings, details);
  }

  saveQarRafTag(baseUrl: string, globalParams: any, filterParams: any, settings: any, details: any[]): Observable<any> {
    return this.postSave(baseUrl, 'yswmqc', 'qar-raf-tag-save', globalParams, filterParams, settings, details);
  }

  deleteQarData(baseUrl: string, globalParams: any, filterParams: any, settings: any, details: any[]): Observable<any> {
    return this.postSave(baseUrl, '0nv1s7', 'qar_delete_data', globalParams, filterParams, settings, details);
  }

  private postSave(
    baseUrl: string,
    actionCode: string,
    processName: string,
    globalParams: any,
    filterParams: any,
    settings: any,
    details: any[]
  ): Observable<any> {
    const mergedParams: any = { ...globalParams, ...filterParams };
    mergedParams.clob_data = JSON.stringify(details);
    mergedParams.clob_settings = JSON.stringify(settings);
    mergedParams.process_name = processName;

    const body = new URLSearchParams();
    Object.keys(mergedParams).forEach(k => {
      if (mergedParams[k] !== undefined && mergedParams[k] !== null) {
        body.set(k, String(mergedParams[k]));
      }
    });

    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this.http.post<any>(
      `${baseUrl}/saveJsonObject?action_code=${actionCode}`,
      body.toString(),
      { headers, withCredentials: true }
    );
  }
}
